import { Box } from "@mui/material";
import { CoreButton, CoreTextBox } from "@verity/components/core";
import { useEffect, useState } from "react";
import i18n from "../../../../i18n";

export const UserPinSetting = (props: { verityFetch: typeof fetch }) => {
	const [userPin, setUserPin] = useState<number>();
	const fetchUserPin = async () => {
		const resp = await props.verityFetch("/api/verity/user/pin");
		const pin = Number(await resp.json());
		setUserPin(pin);
	};

	const generateUserPin = async () => {
		const resp = await props.verityFetch("/api/verity/user/pin", {
			method: "POST",
		});
		const pin = Number(await resp.json());
		setUserPin(pin);
	};

	useEffect(() => {
		fetchUserPin().catch(console.error);
		const intervalId = setInterval(fetchUserPin, 300000);
		return () => clearInterval(intervalId);
	}, []);

	return (
		<Box display="flex" gap="12px" height="80%">
			<CoreTextBox
				readOnly
				value={userPin}
				sx={{ input: { cursor: "not-allowed" } }}
				inputProps={{ "aria-label": i18n.t("portal.webpages.settingsRootTSX.userSecurityPinName") }}
			/>
			<CoreButton sx={{ minWidth: "15%" }} onClick={async () => await generateUserPin()}>
				{i18n.t("portal.components.settings.userPinTSX.renegeratePin")}
			</CoreButton>
		</Box>
	);
};
